import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgetPassword } from '../../services/auth';
import WebsiteNavbar from '../../components/WebsiteUI/WebsiteNavbar';
import '../AuthPage/AuthPage.css';

const ForgetPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setError('Email is required');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email');
      return;
    }
    setError('');
    setIsSubmitting(true);
    try {
      await forgetPassword({ email });
      setEmailSent(true);
    } catch (err) {
      // forgetPassword handles error display via swal
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <WebsiteNavbar />
      <main className="auth-page">
        <div className="auth-page__container">
          <div className="auth-page__image">
            <img src="/assets/website/onboarding/services.png" alt="Ogiso Platform" />
          </div>
          <div className="auth-page__content">
            <div className="auth-form">
              <div className="auth-form__view">
                {emailSent ? (
                  <>
                    <div className="auth-form__header">
                      <div className="auth-form__verify-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ffb700" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" />
                          <path d="M22 6L12 13L2 6" />
                        </svg>
                      </div>
                      <h2 className="auth-form__title">Check Your Email</h2>
                      <p className="auth-form__subtitle">
                        We've sent a password reset link to <strong>{email}</strong>. Please check your inbox.
                      </p>
                    </div>
                    <div className="auth-form__verify-actions">
                      <Link to="/login" className="auth-form__submit" style={{ textDecoration: 'none', textAlign: 'center' }}>
                        Back to Login
                      </Link>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="auth-form__header">
                      <h2 className="auth-form__title">Forgot Password</h2>
                      <p className="auth-form__subtitle">
                        Enter your email address and we'll send you a link to reset your password.
                      </p>
                    </div>
                    <form onSubmit={handleSubmit} className="auth-form__form">
                      <div className="auth-form__field">
                        <label htmlFor="resetEmail" className="auth-form__label">Email Address</label>
                        <input
                          type="email"
                          id="resetEmail"
                          placeholder="john@example.com"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                            if (error) setError('');
                          }}
                          className={`auth-form__input ${error ? 'auth-form__input--error' : ''}`}
                        />
                        {error && <span className="auth-form__error">{error}</span>}
                      </div>
                      <button type="submit" disabled={isSubmitting} className="auth-form__submit">
                        {isSubmitting ? <><span className="auth-form__spinner" />Sending...</> : 'Send Reset Link'}
                      </button>
                    </form>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ForgetPassword;
